import {useEffect} from "react";

export function useAgentPresenceHeartbeat(agent, options = {}) {
    const {
        intervalMs = 90000,
        enabled = true,
    } = options;

    useEffect(() => {
        if (!enabled || !agent) return;

        let intervalId = null;

        const sendHeartbeat = async () => {
            try {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                const raw = JSON.stringify({
                    email: agent.email,
                    id_customer: agent.id_customer,
                });
                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow"
                };
                await fetch(`${process.env.REACT_APP_HEARTBEAT_API}/api/agents/presence/heartbeat`, requestOptions)
                    .then((response) => response.text())
                    .then((result) => console.log("PING",result))
                    .catch((error) => console.error(error));
            } catch {
            }
        };

        const start = () => {
            intervalId = setInterval(sendHeartbeat, intervalMs);
        };

        const stop = () => {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };

        const handleVisibility = () => {
            if (document.visibilityState === "visible") {
                sendHeartbeat();
                start();
            } else {
                stop();
            }
        };

        document.addEventListener("visibilitychange", handleVisibility);
        handleVisibility();

        return () => {
            stop();
            document.removeEventListener("visibilitychange", handleVisibility);
        };
    }, [agent, enabled, intervalMs]);
}
